"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionDetail = void 0;

var _react = require("@lingui/react");

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _dateFns = require("date-fns");

var _Metadata = require("./Metadata");

var _Statuses = require("./Statuses");

var _Team = require("./Team");

var _utils = require("../utils");

var Elements = _interopRequireWildcard(require("../../ActionModal.styles"));

var _EquipListField = require("../../../Action/components/EquipListField");

var _actionField = require("../../../../context/actionField");

var _Accordion = require("../../components/Accordion");

var _utils2 = require("@bueno/blocks/lib/charts/utils");

var _core = require("@lingui/core");

var _lists = require("../../../Action/utils/lists");

var _InlineEdit = require("../../components/InlineEdit");

var _useAxiosSwr = require("../../../../utils/useAxiosSwr");

var _currency = require("../../../../utils/currency");

/* eslint-disable no-eq-null */

/* eslint-disable @typescript-eslint/strict-boolean-expressions */

/* eslint-disable no-void */
const ActionDetail = ({
  withInModal,
  action,
  onActionChange
}) => {
  var _action$description, _action$gas, _action$water, _action$total_financi, _action$operational_s, _action$nabers_energy, _action$nabers_water;

  const {
    updateFields
  } = (0, _actionField.useActions)();
  const {
    data: assigneeData
  } = (0, _useAxiosSwr.useHashtagUsernameList)(action.project_key, action.components);
  const currencySymbol = (0, _currency.useCurrencySymbol)(action.project_key);

  const updateField = (fields, cb) => async () => {
    if (fields.assignee != null) {
      var _assigneeData$find;

      const assigneeId = fields.assignee !== '' ? assigneeData === null || assigneeData === void 0 ? void 0 : (_assigneeData$find = assigneeData.find(assignee => assignee.display === fields.assignee)) === null || _assigneeData$find === void 0 ? void 0 : _assigneeData$find.authId : undefined; // Populate assigneeId for Hydra in addition to `assignee`

      await updateFields(action.key, { ...fields,
        assigneeId
      });
    } else {
      await updateFields(action.key, fields);
    }

    if (onActionChange !== undefined) {
      const jiraFields = (0, _utils.mapToJiraProps)(fields);
      onActionChange({ ...action,
        ...jiraFields,
        updated: (0, _dateFns.format)(new Date(), `yyyy-MM-dd'T'HH:mm:ssXXX`)
      });
    }

    if (cb != null) cb();
  };

  const assignees = React.useMemo(() => {
    if (assigneeData == null) return undefined;
    const mapped = assigneeData.map(a => ({
      value: a.display,
      label: a.display,
      name: a.display,
      key: a.id
    }));
    return (0, _utils2.sortByName)(mapped);
  }, [assigneeData]);
  const actionLabel = `#${(0, _utils.stripProjectPrefix)(action.key)}`;
  const handleSummarySave = React.useCallback(val => {
    void updateField({
      summary: val
    })();
  }, [updateField]);
  const handleDescriptionSave = React.useCallback(val => {
    void updateField({
      description: val
    })();
  }, [updateField]);
  const handleTrendGraphSave = React.useCallback(val => {
    void updateField({
      reportUrl: val
    })();
  }, [updateField]);
  return /*#__PURE__*/React.createElement(Elements.EasyEditWrapper, {
    "data-testid": "Action--Details"
  }, /*#__PURE__*/React.createElement(Elements.Section, null, /*#__PURE__*/React.createElement(Elements.ActionTitle, null, withInModal ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Elements.LinkTitle, {
    to: `/actions/${action.key}`,
    target: "_blank",
    rel: "noopener"
  }, actionLabel, " ", /*#__PURE__*/React.createElement(_blocks.External, {
    tiny: true
  })), ' ', "\u2022 ", action.components) : /*#__PURE__*/React.createElement(React.Fragment, null, actionLabel, " \u2022 ", action.components)), /*#__PURE__*/React.createElement(_Metadata.Metadata, {
    created: action.created,
    creator: action.creator_name_display,
    updated: action.updated
  }), /*#__PURE__*/React.createElement(_blocks.InlineEdit, {
    inputType: "text",
    value: action.summary,
    onSave: handleSummarySave,
    displayComponent: props => /*#__PURE__*/React.createElement(Elements.Summary, {
      "data-testid": "Action--Summary",
      title: _core.i18n._({
        id: 'action_detail.inline_edit_prompt',
        message: `Click to edit`
      })
    }, props.value),
    editComponent: _InlineEdit.SummaryEditField
  }), /*#__PURE__*/React.createElement(_Statuses.Statuses, {
    editFn: updateField,
    status: action.bonfire_status,
    severity: action.priority,
    type: action.context
  }), /*#__PURE__*/React.createElement(Elements.Description, {
    className: !action.description ? 'ActionDetail--Description__no-value' : ''
  }, /*#__PURE__*/React.createElement(Elements.SubduedLabel, null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_detail.description_label"
  })), /*#__PURE__*/React.createElement(_blocks.InlineEdit, {
    inputType: "textarea" // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore Blocks has the wrong type for this, providing an empty
    // string makes the placeholder not show.
    // This also triggers a warning from React, but it's fine.
    ,
    value: action.description === '' ? undefined : (_action$description = action.description) !== null && _action$description !== void 0 ? _action$description : '',
    placeholder: _core.i18n._({
      id: 'action_detail.v2.description_placeholder',
      message: `+ Add Description`
    }),
    onSave: handleDescriptionSave,
    displayComponent: props => /*#__PURE__*/React.createElement("div", {
      title: _core.i18n._({
        id: 'action_detail.inline_edit_prompt',
        message: `Click to edit`
      })
    }, /*#__PURE__*/React.createElement(_blocks.Markdown, null, props.value)),
    editComponent: _InlineEdit.DescriptionEditField
  }))), action.associatedEquips.length > 0 && /*#__PURE__*/React.createElement(_Accordion.Accordion, {
    label: _core.i18n._({
      id: 'action_detail.insights_and_equipment_accordion_label',
      message: `Insights & Equipment`
    }),
    persistId: "insightsAndEquips",
    initialState: withInModal ? undefined : 'open'
  }, /*#__PURE__*/React.createElement(_EquipListField.EquipListField, {
    actionId: action.key,
    equips: action.associatedEquips
  })), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
    label: _core.i18n._({
      id: 'action_detail.team_and_assignee_accordion_label',
      message: `Team & Assignee`
    }),
    persistId: "teamAndAssignee",
    initialState: withInModal ? undefined : 'open'
  }, /*#__PURE__*/React.createElement(_Team.Team, {
    editFn: updateField,
    assignee: action.bonfire_assignee,
    assigneeOptions: assignees,
    team: (0, _lists.getResponsibleMap)(_core.i18n, action.project_key === 'WOOL')[action.responsible],
    teamOptions: (0, _lists.getResponsibleOptions)(_core.i18n, `${action.project_key}~site`)
  })), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
    label: _core.i18n._({
      id: 'action_detail.links_accordion_label',
      message: `Links`
    }),
    persistId: "links",
    initialState: withInModal ? undefined : 'open'
  }, /*#__PURE__*/React.createElement(Elements.SubduedLabel, null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_detail.report_link_label"
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, {
    className: !action.skyspark_link ? 'ActionDetail--ReportLink__no-value' : ''
  }, /*#__PURE__*/React.createElement(_blocks.InlineEdit, {
    inputType: "text",
    value: action.skyspark_link || '' // NOTE: Workaround for no value
    ,
    placeholder: _core.i18n._({
      id: 'action_detail.add_report_link',
      message: `+ Add Report Link`
    }) // NOTE: Workaround for no value
    ,
    onSave: handleTrendGraphSave,
    displayComponent: _InlineEdit.TrendGraphDisplayField,
    editComponent: _InlineEdit.TrendGraphEditField
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.AttachmentsEditField, {
    actionKey: action.key,
    value: action.screenshot_link,
    onSave: val => {
      void updateField({
        screenshotUrl: val
      })();
    }
  }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_accordion_label',
      message: `Estimated Savings`
    }),
    persistId: "estimatedSavings",
    initialState: withInModal ? undefined : 'open'
  }, /*#__PURE__*/React.createElement(_blocks.Body, {
    style: {
      marginBottom: _blocks.spacing.tight
    }
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_detail.utility_savings"
  }))), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_electricity',
      message: `Electricity`
    }),
    onSave: updateField,
    value: action.elec || 0,
    unit: "kWh",
    property: "electricity"
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_gas',
      message: `Gas`
    }),
    onSave: updateField,
    property: "gas",
    value: (_action$gas = action.gas) !== null && _action$gas !== void 0 ? _action$gas : 0,
    unit: "GJ"
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_water',
      message: `Water`
    }),
    onSave: updateField,
    property: "water",
    value: (_action$water = action.water) !== null && _action$water !== void 0 ? _action$water : 0,
    unit: "kL"
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_thermal',
      message: `Thermal`
    }),
    onSave: updateField,
    value: action.thermal || 0,
    unit: "kWh",
    property: "thermal"
  })), /*#__PURE__*/React.createElement(_blocks.Body, {
    style: {
      marginBottom: _blocks.spacing.tight,
      marginTop: _blocks.spacing.default
    }
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_detail.cost_savings"
  }), " (", currencySymbol, ")")), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_energy',
      message: `Utility`
    }),
    onSave: updateField,
    property: "totalFinancialImpact",
    value: (_action$total_financi = action.total_financial_impact) !== null && _action$total_financi !== void 0 ? _action$total_financi : 0,
    unit: currencySymbol,
    isCost: true
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.estimated_savings_operational',
      message: `Operational`
    }),
    onSave: updateField,
    property: "operationalSavings",
    value: (_action$operational_s = action.operational_savings) !== null && _action$operational_s !== void 0 ? _action$operational_s : 0,
    unit: currencySymbol,
    isCost: true
  })), /*#__PURE__*/React.createElement(_blocks.Body, {
    style: {
      marginBottom: _blocks.spacing.tight,
      marginTop: _blocks.spacing.default
    }
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(_react.Trans, {
    id: "action_detail.nabers_impact"
  }))), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.nabers_energy',
      message: `NABERS Energy`
    }),
    onSave: updateField,
    property: "nabersEnergy",
    value: (_action$nabers_energy = action.nabers_energy) !== null && _action$nabers_energy !== void 0 ? _action$nabers_energy : 0,
    unit: "star"
  })), /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.nabers_water',
      message: `NABERS Water`
    }),
    onSave: updateField,
    property: "nabersWater",
    value: (_action$nabers_water = action.nabers_water) !== null && _action$nabers_water !== void 0 ? _action$nabers_water : 0,
    unit: "star"
  }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
    label: _core.i18n._({
      id: 'action_detail.costs_label',
      message: `Costs`
    }),
    persistId: "costs",
    initialState: withInModal ? undefined : 'open'
  }, /*#__PURE__*/React.createElement(Elements.InlineEditField, null, /*#__PURE__*/React.createElement(_InlineEdit.SavingsEditField, {
    label: _core.i18n._({
      id: 'action_detail.cost_to_complete',
      message: `Cost to complete`
    }),
    onSave: updateField,
    value: action.cost_to_complete || 0,
    unit: currencySymbol,
    property: "costToComplete",
    isCost: true
  }))));
};

exports.ActionDetail = ActionDetail;